/* eslint-disable import/prefer-default-export */
export const PAGES_MENU_DISPLAY_COUNT = 10;

export const PAGE_SETTINGS_PAGE_DROPDOWN_COUNT = 25;

export const DEFAULT_DOMAIN = 'www.domain.com';
